import React from 'react';
import { Row, Col, Button, FormControl } from 'react-bootstrap'

import Loading from '../../components/shared/Loading'
import ConvertibleText from '../../components/shared/ConvertibleText'

class ListContainer extends React.Component {
  constructor(props) {
    super(props);

    const defaultList = [{
      key: 1,
      text: '',
    }];
    const list = props.list ? props.list : defaultList;
    this.state = {
      list
    };

    this.onBlurHandler = this.onBlurHandler.bind(this);
    this.addList = this.addList.bind(this);
    this.deleteList = this.deleteList.bind(this);
  }

  componentDidMount() {
    const { list } = this.state;
    const listUpdate = {};
    listUpdate[this.props.id] = list;
    this.props.onBlurHandler(listUpdate);
  }
  onBlurHandler(key,event) {
    const { list } = this.state;
    const text = event.target.value;
    const updatedList = list.map(item => {
      if (item.key === key) {
        return {
          key,
          text
        }
      }
      return item;
    });
    this.setState({ list: updatedList });
    const listUpdate = {};
    listUpdate[this.props.id] = updatedList;
    this.props.onBlurHandler(listUpdate);
  }

  addList() {
    const { list } = this.state;
    const nextKey = Math.max.apply(Math, list.map(item => item.key)) + 1;
    const nextList = {
      key: nextKey,
      text: ''
    };
    list.push(nextList);
    this.setState({ list });
    const listUpdate = {};
    listUpdate[this.props.id] = list;
    this.props.onBlurHandler(listUpdate);
  }

  deleteList(key) {
    const { list } = this.state;
    const updatedList = list.filter(item => item.key !== key);
    this.setState({ list: updatedList });
    const listUpdate = {};
    listUpdate[this.props.id] = updatedList;
    this.props.onBlurHandler(listUpdate);
  }

  render() {
    const { list } = this.state;
    const isModified = false;
    const listToDisplay = list.map((item, index) => {
      return (
        <div key={item.key}>
          <Row >
            <Col xs={8} md={6}>
              <div className="premiumGrid">
                <span className="h4 list-input">{
                  isModified
                    ? <Loading width="23px" height="23px" />
                    : <FormControl
                      autoComplete={true}
                      id={`${item.key}`}
                      type='text'
                      componentClass='input'
                      defaultValue={item.text}
                      onBlur={(event)=>this.onBlurHandler(item.key,event)}
                      placeholder={this.props.placeholder ? this.props.placeholder : ''}
                    />
                }
                </span>
              </div>
            </Col>
            <Col>
              {index !== 0 &&
                <Button className="list-minus" onClick={() => this.deleteList(item.key)}>
                  <i className="fa fa-minus-circle fa-lg" title="Delete List" aria-hidden="true" />
                </Button>
              }
            </Col>
          </Row>
        </div>
      )
    });
    return (
      <div>
        <div className="list-header">
          <h4 className="list-title">{this.props.title}</h4>
          <button className="list-add" onClick={this.addList}>
            <i className="fa fa-plus-circle fa-lg" title="Add List" aria-hidden="true" />
          </button>
        </div>
        {listToDisplay}
      </div>
    )
  }
}

export default ListContainer